module.exports = __webpack_public_path__ + "static/media/hero-kerrisdale-aerial.b7b375bf.jpeg";